import React, { forwardRef } from 'react';
import styles from '../styles/ScrollingBanner.module.css';

const ScrollingBanner = forwardRef(({
  content,           // Array of text segments (will be joined with " • ")
  speed = 20,        // Animation duration in seconds
  backgroundColor,   // Background color
  textColor,         // Text color
  fontWeight = 'normal', // 'normal' or 'bold'
  isSticky = false,  // Whether banner should stick to top
  zIndex = 10,       // Z-index for stacking
  borderColor,       // Border color (optional)
  borderWidth = 0    // Border width in pixels (default 0 = no border)
}, ref) => {
  // Join content array with bullet separator
  const displayText = content.join(' • ');

  // Duplicate text for seamless loop
  const duplicatedText = `${displayText} • ${displayText} • ${displayText}`;

  return (
    <div
      ref={ref}
      className={`${styles.scrollingBanner} ${isSticky ? styles.sticky : ''}`}
      style={{
        backgroundColor,
        zIndex: isSticky ? zIndex : 1,
        border: borderWidth > 0 ? `${borderWidth}px solid ${borderColor}` : 'none'
      }}
    >
      <div
        className={styles.scrollingText}
        style={{
          color: textColor,
          fontWeight,
          animationDuration: `${speed}s`
        }}
      >
        {duplicatedText}
      </div>
    </div>
  );
});

ScrollingBanner.displayName = 'ScrollingBanner';

export default ScrollingBanner;
